module.exports = __webpack_public_path__ + "410503d89c9b91465d7eb62fe8cd0a11.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/beady-24.png
// module id = 2010
// module chunks = 0